import { useEffect, useState } from 'react';
import API from '../../api';

// redux
import { mapDispatchProps, mapStateToProps } from '../../store/store';
import { connect } from 'react-redux';
import { X } from 'react-feather';
import Button from '../../components/button';
import CardSelect from '../../pages/cards/select';
import { debounce } from '../../helpers/debounce';
import Checkbox, { ICON_TYPES } from '../../components/checkbox';
import { useLanguage } from '@languages/index';
import { useStripe } from '@stripe/react-stripe-js';
import RadioButton from 'components/radioButton';
import { BRAND_BILLING_TYPES } from 'store/brand/reducer';
import * as HELPER_CURRENCY from 'helpers/currency';
import { PAYMENT_PRODUCT_TYPE } from 'constants/payment';
import { OverlayBrandTaxInvoiceInfoFormResult } from 'components/overlayBrandTaxInvoiceInfoForm';

interface PaymentCreatePropTypes {
  summary?: any;

  temporaryKey?: any;
  campaignId?: any;
  productId?: any;

  handleChange?: any;

  itemType: any;
  amount: number;
  price: number;
  commissionPrice?: number | null;
  commissionIncreasedApplicants?: any[] | null;
  inspectionFee?: number | null;
  priceTotal?: number;

  cashCampaignPaymentData?: Pick<
    OverlayBrandTaxInvoiceInfoFormResult['data']['campaignPayment'], 
    keyof OverlayBrandTaxInvoiceInfoFormResult['data']['campaignPayment']
  > | null

  brand?: any;
  auth?: any;
  preferences?: any;
  settings?: any;

  campaignData?: any;
  productData?: any;

  onSuccess?: any;

  setPopup?: (params?: any) => void;
  closePopup?: () => void;

  showSheet?: (params?: any) => void;
  closeSheet?: () => void;

  showModal?: (params?: any) => void;
  closeModal?: () => void;

  showOverlays?: (params?: any) => void;
  closeOverlays?: () => void;
}

const PaymentCreateAdditionalSeeding = (props: PaymentCreatePropTypes) => {
  const stripe = useStripe();
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.payments };

  const PRODUCT_DURATIONS_VALUE_SINGLE = 'month';
  const PRODUCT_DURATIONS_VALUE_YEARLY = 'year';

  const PRODUCT_DURATION_SINGLE = {
    value: PRODUCT_DURATIONS_VALUE_SINGLE,
    name: languageTexts.create_text_20,
    price: props.brand.priceSeeding,
  };

  const PRODUCT_DURATION_YEARLY = {
    value: PRODUCT_DURATIONS_VALUE_YEARLY,
    name: languageTexts.create_text_21,
    price: props.brand.priceSeedingPass,
  };

  const PRODUCT_DURATIONS = [PRODUCT_DURATION_SINGLE, PRODUCT_DURATION_YEARLY];

  const [isPending, setIsPending] = useState(false);
  const [isAgreed, setIsAgreed] = useState(true);

  const [itemType, setItemType] = useState(props.itemType);
  const [productDuration, setProductDuration] = useState(
    [
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS,
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY,
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_RECOVER,
    ].indexOf(props.itemType) >= 0
      ? PRODUCT_DURATION_YEARLY
      : PRODUCT_DURATION_SINGLE,
  );
  const [amount, setAmount] = useState(props.amount);

  const getPrice = () => {
    // if (props.brand.billingType == BRAND_BILLING_TYPES.FREE) return 0
    if (props.price != null) return props.price;
    return PRODUCT_DURATION_SINGLE.price;
  };

  const [price, setPrice] = useState(getPrice());

  const getPriceTotal = () => {
    // if (props.brand.billingType == BRAND_BILLING_TYPES.FREE) return 0
    if (props.priceTotal) return props.priceTotal;
    return PRODUCT_DURATION_SINGLE.price * amount;
  };

  const [priceTotal, setPriceTotal] = useState(getPriceTotal());

  // useEffect(() => {
  //   let amountToPay = 0
  //   const hasSeedingPass = props.brand.remainSeedingPass

  //   if (productDuration && props.brand.isCategoryBeauty) {
  //     switch (productDuration.value) {
  //       case PRODUCT_DURATIONS_VALUE_SINGLE:
  //         if (!hasSeedingPass) amountToPay += parseInt(PRODUCT_DURATION_SINGLE.price) * props.amount
  //         if (props.commissionPrice) amountToPay += props.commissionPrice * props.amount

  //         setPrice(props.brand.billingType == BRAND_BILLING_TYPES.FREE ? 0 : PRODUCT_DURATION_SINGLE.price)
  //         setPriceTotal(props.brand.billingType == BRAND_BILLING_TYPES.FREE ? 0 : amountToPay)
  //         if (props.brand.remainSeedingPass) {
  //           setItemType(PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_COMMISSION_ONLY)
  //         } else {
  //           setItemType(PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE)
  //         }
  //         break

  //       case PRODUCT_DURATIONS_VALUE_YEARLY:
  //         if (!hasSeedingPass) amountToPay += parseInt(PRODUCT_DURATION_YEARLY.price)
  //         if (props.commissionPrice) amountToPay += props.commissionPrice * props.amount

  //         setPrice(props.brand.billingType == BRAND_BILLING_TYPES.FREE ? 0 : PRODUCT_DURATION_YEARLY.price)
  //         setPriceTotal(props.brand.billingType == BRAND_BILLING_TYPES.FREE ? 0 : amountToPay)
  //         setItemType(PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY)
  //         break
  //     }
  //   }
  // }, [productDuration, props.commissionPrice])

  useEffect(() => {
    // DEBUG
    let priceInspection = props.inspectionFee != null ? props.inspectionFee : 0;
    let calculation =
      price * amount +
      props.commissionPrice * amount +
      priceInspection * amount;
    let debugValues = {
      price,
      amount,
      commissionAmount: props.commissionPrice,
      priceInspection,
      priceTotal,
      calculation,
    };
    console.log('Debug values:', debugValues);
  }, [price, amount, props.commissionPrice, props.inspectionFee]);

  const getProductName = () => {
    let result = '';
    switch (itemType) {
      case PAYMENT_PRODUCT_TYPE.SEEDING_FIRST:
        result = languageTexts.create_text_2;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS:
        result = languageTexts.create_text_3;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_RECOVER:
        result = languageTexts.create_text_4;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING:
        result = languageTexts.create_text_5;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_COMMISSION:
        result = languageTexts.create_text_16;
        break;

      case PAYMENT_PRODUCT_TYPE.SNS_PASS:
      case PAYMENT_PRODUCT_TYPE.SNS_INSTALL:
        result = languageTexts.create_text_6;
        break;

      case PAYMENT_PRODUCT_TYPE.SNS_PASS_RECOVER:
        result = languageTexts.create_text_7;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE:
      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY:
      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_COMMISSION_ONLY:
        result = languageTexts.create_text_17;
        break;
    }
    return result;
  };

  const getPaymentDetails = () => {
    let details = [];
    if (props.commissionPrice) {
      details.push({
        name: languageTexts.create_text_26,
        description: `${props.commissionPrice.toLocaleString()}${
          props.settings.currencyText
        } * ${languageTexts._amount(amount)}`,
      });
    }
    if (
      productDuration &&
      productDuration.value == PRODUCT_DURATION_YEARLY.value
    ) {
      details.push({
        name: languageTexts.create_text_21,
        description: `${parseInt(
          props.brand.priceSeedingPass,
        ).toLocaleString()}${props.settings.currencyText}`,
      });
    }
    if (getProductPrice() != languageTexts.free) {
      details.push({
        name: languageTexts.create_text_17,
        description: `${getProductPrice().toLocaleString()} * ${languageTexts._amount(
          amount,
        )}`,
      });
    }
    if (props.inspectionFee != null) {
      details.push({
        name: languageTexts.create_text_27,
        description: `${props.inspectionFee.toLocaleString()}${
          props.settings.currencyText
        } * ${languageTexts._amount(amount)}`,
      });
    }
    return details;
  };

  const renderTitle = () => {
    return (
      <div className="flex flex-row items-center md:pt-[50px] pb-[30px]">
        <div className="flex flex-row justify-center items-center">
          <span className="text-[22px] font-bold text-center md:text-start">{`${languageTexts.pay}`}</span>
        </div>

        <div
          className="cursor-pointer items-center absolute right-0 top-0 m-[30px]"
          onClick={() => {
            props.closeOverlays();
          }}
        >
          <div>
            <X size={24} strokeWidth={1} />
          </div>
        </div>
      </div>
    );
  };

  const getTaxedPrice = (
    price: number,
    taxRate: number,
    decimalPlaces: number,
  ) => {
    const decimal = 10 ** decimalPlaces;
    return Math.round(price * (1 + taxRate) * decimal) / decimal;
  };

  const getProductPrice = () => {
    if (!props.brand.isCategoryBeauty) {
      if (
        productDuration &&
        (props.brand.remainSeedingPass ||
          productDuration.value == PRODUCT_DURATION_YEARLY.value)
      ) {
        return languageTexts.free;
      }
      if (price === 0) return languageTexts.free;
    }

    return languageTexts._price(
      parseInt(price).toLocaleString(),
      props.settings.currencyText,
    );
  };

  const getLocalePriceText = (price: any) => {
    return languageTexts._price(
      parseInt(price).toLocaleString(),
      props.settings.currencyText,
    );
  };

  const getProductPrefix = () => {
    const isGettingPaidPerEach = [
      PAYMENT_PRODUCT_TYPE.SEEDING,
      PAYMENT_PRODUCT_TYPE.SEEDING_COMMISSION,
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE,
    ].includes(itemType);

    if (getProductPrice() == languageTexts.free) return '';
    if (isGettingPaidPerEach) return `${languageTexts.create_text_per_each} `;
    return '';
  };

  const getPriceTotalWithCommissions = () => {
    // if (props.brand.billingType == BRAND_BILLING_TYPES.FREE) return 0
    let recalculatedPriceTotal = price * amount;

    if (props.commissionPrice) {
      recalculatedPriceTotal += props.commissionPrice * amount;
    }
    if (props.inspectionFee) {
      recalculatedPriceTotal += props.inspectionFee * amount;
    }

    // if (props.commissionIncreasedApplicants?.length > 0) {
    //   recalculatedPriceTotal += getPriceWithCommissionsIncreased()
    // }

    return priceTotal
      ? Math.round(priceTotal)
      : Math.round(recalculatedPriceTotal);
  };

  const getPriceTotalCombined = () => {
    return getPriceTotalWithCommissions() + getPriceWithCommissionsIncreased();
  };

  const calculateCommissionIncreased = (
    applicantCommission,
    campaignCommission,
  ) => {
    if (
      applicantCommission == null ||
      campaignCommission == null ||
      applicantCommission <= campaignCommission
    ) {
      return 0;
    }
    const currencyMultiplier = HELPER_CURRENCY.getCurrencyMultiplier(
      props.brand.currency,
    );
    return (applicantCommission - campaignCommission) * currencyMultiplier;
  };

  const getPriceWithCommissionsIncreased = () => {
    return (
      props?.commissionIncreasedApplicants?.reduce(
        (sum, applicant) =>
          sum +
          calculateCommissionIncreased(
            applicant.commissionAmount,
            props.campaignData.commissionAmount,
          ),
        0,
      ) || 0
    );
  };

  const renderSummary = () => {
    console.log(`amount: ${amount} productData.qty: ${props.productData.qty}`);
    return (
      <>
        <div className="flex flex-col">
          {amount > 0 ? (
            <div className="flex flex-col">
              <div className="flex flex-row">
                <span className="font-bold text-[22px]">
                  {languageTexts.create_text_additional_selection_section_title}
                </span>
              </div>

              <div className="flex flex-row my-[15px]">
                <div className="border-t border-[#E8E8E8] w-full" />
              </div>

              <div className="flex flex-col gap-[15px]">
                {/* 원고료 결제 비용 */}
                {props.commissionPrice ? (
                  <div className="flex flex-row justify-between">
                    <div className="flex flex-col">
                      <span className="font-bold text-[15px] tracking-tighter max-w-[115px]">
                        {`${languageTexts.create_text_26}`}
                      </span>
                    </div>

                    <div>
                      <span className="text-[15px] tracking-tighter text-right">
                        {`${languageTexts.create_text_per_each} ${getLocalePriceText(props.commissionPrice)}`}
                      </span>
                    </div>
                  </div>
                ) : null}

                {/* 사전 검수 비용 */}
                {props?.inspectionFee != null && (
                  <div className="flex flex-row justify-between">
                    <div className="flex flex-col justify-center">
                      <span className="font-bold text-[15px] tracking-tighter max-w-[115px]">
                        {languageTexts.create_text_27}
                      </span>
                    </div>
                    <div className="flex flex-col justify-center gap-1">
                      <span className="text-[15px] tracking-tighter text-right">{`${getProductPrefix()}${getLocalePriceText(
                        props.inspectionFee,
                      )}`}</span>
                    </div>
                  </div>
                )}

                {/* 제품 이름 */}
                {/* 서비스 이용료, 제품 증정, 제품 증정 무제한, ... */}
                <div className="flex flex-row justify-between">
                  <div className="flex flex-col justify-center">
                    <span className="font-bold text-[15px] tracking-tighter max-w-[115px]">{`${getProductName()}`}</span>
                  </div>

                  <div className="flex flex-col justify-center gap-1">
                    <span className="text-[15px] tracking-tighter text-right">{`${getProductPrefix()}${getProductPrice()}`}</span>
                  </div>
                </div>

                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-col justify-center">
                    <span className="font-bold text-[15px] tracking-tighter">
                      {`${languageTexts.create_text_additional}${languageTexts.create_text_18}`}
                    </span>
                  </div>

                  <div className="flex flex-col justify-center gap-1">
                    <span className="text-[15px] tracking-tighter text-right">
                      {languageTexts.create_text_total_amount(amount)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex flex-row my-[15px]">
                <div className="border-t border-[#E8E8E8] w-full" />
              </div>

              <div className="flex flex-row justify-between">
                <div className="flex flex-col"></div>
                <div className="flex flex-col">
                  <div className="flex flex-row">
                    <div className="flex flex-col">
                      {/* {`(`} */}

                      {getPaymentDetails().map((item, index) => {
                        return (
                          <span
                            key={index}
                            className="text-[15px] text-[#999999] text-right"
                          >
                            {`${item.name} `}
                            {`${item.description}`}
                          </span>
                        );
                      })}

                      {/* {`)`} */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-2 mt-[15px]">
                <div className="flex flex-row justify-between">
                  <div className="flex flex-col justify-center">
                    <span className="font-bold text-[15px] tracking-tighter">
                      {languageTexts.create_text_19}
                    </span>
                  </div>
                  <div className="flex flex-col justify-center gap-1">
                    <span className="text-[15px] tracking-tighter text-right">
                      {getLocalePriceText(getPriceTotalWithCommissions())}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <div className="h-[50px]" />

          {props?.commissionIncreasedApplicants?.length > 0 ? (
            <div className="flex flex-col">
              <div className="flex flex-row">
                <span className="font-bold text-[22px]">
                  {languageTexts.create_text_commission_increased_section_title}
                </span>
              </div>

              <div className="flex flex-row my-[15px]">
                <div className="border-t border-[#E8E8E8] w-full" />
              </div>

              <div className="flex flex-col gap-[15px]">
                {/* 원고료 상향 지원으로 인한 추가 비용 */}
                {props?.commissionIncreasedApplicants.map((applicant) => {
                  return (
                    <div className="flex flex-row justify-between">
                      <div className="flex flex-col justify-center">
                        <span className="font-bold text-[15px] tracking-tighter max-w-[115px]">
                          {applicant.user.username}
                        </span>
                      </div>
                      <div className="flex flex-col justify-center gap-1">
                        <span className="text-[15px] tracking-tighter text-right">
                          {`${getLocalePriceText(
                            calculateCommissionIncreased(
                              applicant.commissionAmount,
                              props.campaignData.commissionAmount,
                            ),
                          )}`}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="flex flex-row my-[15px]">
                <div className="border-t border-[#E8E8E8] w-full" />
              </div>

              <div className="flex flex-col gap-2 mt-[15px]">
                <div className="flex flex-row justify-between">
                  <div className="flex flex-col justify-center">
                    <span className="font-bold text-[15px] tracking-tighter">
                      {languageTexts.create_text_19}
                    </span>
                  </div>
                  <div className="flex flex-col justify-center gap-1">
                    <span className="text-[15px] tracking-tighter text-right">
                      {getLocalePriceText(getPriceWithCommissionsIncreased())}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <div className="flex flex-col">
            <div className="flex flex-row my-[15px]">
              <div className="border-t border-black w-full" />
            </div>

            <div className="flex flex-row justify-between">
              <div className="flex flex-col justify-center">
                <span className="font-bold text-[15px] tracking-tighter">
                  {languageTexts.create_text_19}
                </span>
              </div>
              <div className="flex flex-col justify-center gap-1">
                <span className="text-[15px] tracking-tighter text-right">
                  {getLocalePriceText(getPriceTotalCombined())}
                </span>
              </div>
            </div>

            <div className="flex flex-row justify-between mt-[10px]">
              <div className="flex flex-col justify-center">
                <span className="font-bold text-[15px] tracking-tighter">
                  {languageTexts.complete_text_24}
                </span>
              </div>
              <div className="flex flex-col justify-center">
                <span className="font-bold text-[22px] tracking-tighter">
                  {languageTexts._price(
                    getTaxedPrice(
                      getPriceTotalCombined(),
                      0.1,
                      0,
                    ).toLocaleString(),
                    props.settings.currencyText,
                  )}
                </span>
              </div>
            </div>
            <div className="flex flex-row my-[20px]">
              <div className="border-t border-black w-full" />
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderProceedPaymentButton = () => {
    const isActiveCardExists = props.brand.cards && props.brand.cards.length;
    const isFreeBrand = props.brand.billingType === BRAND_BILLING_TYPES.FREE;

    let buttonColor = '#919191';
    if ((isFreeBrand || isActiveCardExists) && isAgreed && !isPending)
      buttonColor = 'BLACK';

    const getText = () => {
      if (isPending) return languageTexts.create_text_13;
      if (!isAgreed) return languageTexts.create_text_14;

      return `${languageTexts.create_text_additional}${languageTexts.pay}`;
    };

    return (
      <div className="fixed md:relative md:w-auto bottom-0 left-0 right-0 form-submit-button">
        {isFreeBrand && (
          <div className="mb-[4px] text-center text-[14px] text-[#FF4040] font-bold">
            {languageTexts.create_text_cash_brand_warning}
          </div>
        )}
        <Button
          textColor={'WHITE'}
          buttonColor={buttonColor}
          borderColor={buttonColor}
          text={getText()}
          onClick={
            isPending || !isAgreed
              ? () => {}
              : () => {
                  API.Card.index({
                    ...{
                      brandToken: props.auth.token,
                    },
                  })
                    .then((response) => {
                      const fetchedCards = response.data.cards.data;
                      if (!fetchedCards.length && !isFreeBrand) {
                        props.showModal({ text: languageTexts.create_text_15 });
                        setIsPending(false);
                        return false;
                      }
                      
                      if (isPending) return false;
                      setIsPending(true);

                      debounce(async () => {
                        try {
                          const commissionIncreasedApplicants = [];
                          props.commissionIncreasedApplicants?.forEach(
                            (applicant) => {
                              commissionIncreasedApplicants.push(
                                applicant.userId,
                              );
                            },
                          );

                          const response = await API.Payment.proceed({
                            isAdditionalSeeding: props.amount ? true : false,
                            commissionIncreasedApplicants:
                              commissionIncreasedApplicants?.length
                                ? commissionIncreasedApplicants.join(',')
                                : false,
                            temporaryKey: props.temporaryKey,
                            campaignId: props.campaignId,
                            productId: props.productId,
                            brandToken: props.auth.token,
                            itemType: itemType,
                            amount: amount,
                            price: getPrice(),
                            priceTotal: getTaxedPrice(
                              getPriceTotalCombined(),
                              0.1,
                              0,
                            ), // 주의: 세금 포함
                            commissionAmount: props.commissionPrice,
                            inspectionFee: props.inspectionFee,

                            // 이하 현금결제관련
                            taxInvoiceScheduledDate: props.cashCampaignPaymentData?.taxInvoiceScheduledDate,
                            depositScheduledDate: props.cashCampaignPaymentData?.depositScheduledDate,
                          });

                          props.closeOverlays();

                          setTimeout(() => {
                            props.onSuccess
                              ? props.onSuccess({
                                  itemType: itemType,
                                  amount: amount,
                                  price: getPrice(),
                                  priceTotal: getTaxedPrice(
                                    getPriceTotalCombined(),
                                    0.1,
                                    0,
                                  ), // 주의: 세금 포함
                                  payment: response.data.payment,
                                  paymentDetails: getPaymentDetails(),
                                  commissionAmount: props.commissionPrice,
                                  inspectionFee: props.inspectionFee,
                                })
                              : null;
                          }, 400);

                          setTimeout(() => {
                            setIsPending(false);
                          }, 1000);
                        } catch (paymentResponse) {
                          if (paymentResponse.message == 'requires_action') {
                            props.showModal({
                              text: '현재 이용할 수 없는 카드 입니다. 다른 카드를 이용해주세요.',
                            });
                            return false;

                            // const { error, paymentIntent } = await stripe.confirmCardPayment(
                            //   paymentResponse.data.payment_intent_client_secret
                            // )

                            // if (error) {
                            // props.showModal({ text: error.message })
                            //   return
                            // }

                            // The payment requires additional confirmation
                            // const confirmResponse = await fetch("/your-backend-confirm-route", {
                            //   method: "POST",
                            //   headers: {
                            //     "Content-Type": "application/json",
                            //   },
                            //   body: JSON.stringify({ paymentIntentId: paymentIntent.id }),
                            // })

                            // const confirmResult = await confirmResponse.json()

                            // if (confirmResult.error) {
                            //   console.error(confirmResult.error)
                            //   alert("Payment failed: " + confirmResult.error)
                            // } else {
                            //   alert("Payment successful!")
                            // }

                            return false;
                          }

                          props.showModal({ text: paymentResponse.message });
                        }
                      }, 400);
                    })
                    .catch((error) => {
                      setTimeout(() => {
                        props.showModal({ text: error.message });
                      }, 400);
                    });
                }
          }
        />
      </div>
    );
  };

  const renderCards = () => {
    return (
      <div className="flex flex-col w-full my-[40px] max-w-[370px] mx-auto">
        <CardSelect cardsContainerClassName="p-0" hidePageTitle={true} />
      </div>
    );
  };

  const renderTerms = () => {
    const isAgreeRequired =
      itemType == PAYMENT_PRODUCT_TYPE.SEEDING_PASS ||
      itemType == PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY;

    return (
      <>
        {isAgreeRequired ? (
          <div className="flex flex-row justify-between py-[22px] mx-auto">
            <div className="flex flex-col justify-center gap-1 items-end">
              <Checkbox
                text={languageTexts.create_text_12}
                textClassName={'text-[15px] tracking-tighter text-right'}
                type={ICON_TYPES.DEFAULT}
                checked={isAgreed}
                onClick={() => {
                  setIsAgreed(!isAgreed);
                }}
              />
            </div>
          </div>
        ) : (
          <div className="h-[40px]" />
        )}
      </>
    );
  };

  const renderActiveSeedingPass = () => {
    const isBeautyProduct = [
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE,
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY,
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_COMMISSION_ONLY,
    ].includes(itemType);

    if (isBeautyProduct) return null;
    if (!props.brand.activeSeedingPassEndsAt) return null;

    return (
      <div className="flex flex-col">
        <div className="flex flex-col items-center justify-center py-[15px] bg-[#F4F4F4]">
          <h3 className="text-[15px] font-bold mb-[5px]">
            {`${
              props.brand.isCategoryFashion ? languageTexts.create_text_25 : ''
            } `}
            {`${
              props.brand.isCategoryBeauty ? languageTexts.create_text_21 : ''
            } `}
            {`${languageTexts.create_text_pass_using}`}
          </h3>
          <p className="text-[15px] text-[#999999]">
            {`${props.brand.activeSeedingPassStartedAt} ~ ${props.brand.activeSeedingPassEndsAt}`}
          </p>
        </div>
        <div className="h-[40px]" />
      </div>
    );
  };

  const renderProductDurationSelector = () => {
    const isVisible = [
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE,
      PAYMENT_PRODUCT_TYPE.SEEDING,
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY,
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS,
    ].includes(itemType);

    const isDurationSelectable = [
      // PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE,
      // PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY,
    ].includes(itemType);

    const isSeedingPass = [
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS,
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY,
    ].includes(itemType);
    const isSeedingSingle = [
      PAYMENT_PRODUCT_TYPE.SEEDING,
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE,
    ].includes(itemType);

    if (!isVisible) return null;
    if (props.brand.activeSeedingPassEndsAt) return null;

    return (
      <div className="flex flex-col pb-[40px] gap-[15px]">
        {isDurationSelectable ? (
          <div className="flex flex-row">
            <RadioButton
              tabClassName="px-[10px] py-3"
              selectedClassName="px-[10px] py-3 bg-black font-bold"
              selectedTextColor="WHITE"
              options={PRODUCT_DURATIONS}
              selected={productDuration}
              onSelect={(option) => setProductDuration(option)}
            />
          </div>
        ) : null}

        {isSeedingPass ? (
          <div className="flex flex-row">
            <RadioButton
              tabClassName="px-[10px] py-3"
              selectedClassName="px-[10px] py-3 bg-black font-bold"
              selectedTextColor="WHITE"
              options={[
                {
                  name: languageTexts.create_text_25,
                  price: props.brand.priceSeedingPass,
                  value: itemType,
                },
              ]}
              selected={{
                name: languageTexts.create_text_25,
                price: props.brand.priceSeedingPass,
                value: itemType,
              }}
              onSelect={(option) => true}
            />
          </div>
        ) : null}

        {isSeedingSingle ? (
          <div className="flex flex-row">
            <RadioButton
              tabClassName="px-[10px] py-3"
              selectedClassName="px-[10px] py-3 bg-black font-bold"
              selectedTextColor="WHITE"
              options={[
                {
                  name: languageTexts.create_text_20,
                  price: props.brand.priceSeeding,
                  value: itemType,
                },
              ]}
              selected={{
                name: languageTexts.create_text_20,
                price: props.brand.priceSeeding,
                value: itemType,
              }}
              onSelect={(option) => true}
            />
          </div>
        ) : null}

        {itemType == PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE ||
        itemType == PAYMENT_PRODUCT_TYPE.SEEDING ? (
          <div className="flex flex-row justify-center items-center">
            <span className="text-[15px] text-[#999999]">
              {languageTexts.create_text_22}
            </span>
          </div>
        ) : null}

        {itemType == PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY ? (
          <div className="flex flex-row justify-center items-center">
            <span className="text-[15px] text-[#999999]">
              {languageTexts.create_text_23}
            </span>
          </div>
        ) : null}

        {itemType == PAYMENT_PRODUCT_TYPE.SEEDING_PASS ? (
          <div className="flex flex-row justify-center items-center">
            <span className="text-[15px] text-[#999999]">
              {languageTexts.create_text_24}
            </span>
          </div>
        ) : null}
      </div>
    );
  };

  let containerStyle = '';
  if (props.preferences.isMobile) {
    containerStyle =
      'h-[100dvh] flex flex-col overflow-scroll bg-white w-[100dvw] px-5 py-5';
  } else {
    containerStyle =
      'relative w-full flex flex-col rounded-t-2xl overflow-y-auto max-h-[100dvh] px-[50px] bg-white pb-[50px] w-[480px]';
  }

  return (
    <>
      <div className={`${containerStyle}`}>
        {renderTitle()}
        {renderActiveSeedingPass()}
        {/* {renderProductDurationSelector()} */}
        {renderSummary()}
        {renderCards()}
        {renderTerms()}
        {renderProceedPaymentButton()}
      </div>
    </>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchProps,
)(PaymentCreateAdditionalSeeding);
